export default __webpack_public_path__ + "static/media/easymentainancy.50ed5c88.png";